/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconUnderline = createReactComponent("underline", "IconUnderline", [
  ["path", { d: "M7 5v5a5 5 0 0 0 10 0v-5", key: "svg-0" }],
  ["path", { d: "M5 19h14", key: "svg-1" }]
]);

export { IconUnderline as default };
//# sourceMappingURL=IconUnderline.js.map
